// extracted by mini-css-extract-plugin
module.exports = {"comparison":"BestelInfoPagina_comparison__tlJPj","previewImage":"BestelInfoPagina_previewImage__11i-V","orderButton":"BestelInfoPagina_orderButton__6_QGS"};